const SEARCH_TOKEN_PATTERN = /[a-z0-9]+/gi;

export const tokenizeSearchQuery = (query, { minTokenLength = 2 } = {}) => {
  const raw = String(query || '').trim().toLowerCase();
  if (!raw) return [];

  const tokens = raw.match(SEARCH_TOKEN_PATTERN) || [];
  const seen = new Set();

  return tokens
    .map((token) => token.trim())
    .filter((token) => token.length >= minTokenLength)
    .filter((token) => {
      if (seen.has(token)) return false;
      seen.add(token);
      return true;
    });
};

export const matchesTokenizedSearch = (query, values = []) => {
  const tokens = tokenizeSearchQuery(query);
  if (!tokens.length) return false;

  const haystack = (Array.isArray(values) ? values : [])
    .map((value) => String(value || '').toLowerCase())
    .filter(Boolean)
    .join(' ');

  if (!haystack) return false;

  return tokens.every((token) => haystack.includes(token));
};
